class BaseComponent {
    constructor(debugName = "") {
        this.debugName = debugName;
        this.circuitId = null;
    }
}

export default BaseComponent;
